module.exports = __webpack_public_path__ + "img/B0B0B0_6E6E6E_848484_8C8C8C-256px.11b079c4.png";